import m from "mithril";
import { getSerialCodes } from "./serial-codes";
import { APP_TITLE } from "./common";
import { BoxFrameView, MainLContent, PrimaryBoxFrameView, SimpleFooter, SimpleHeader } from "./hamajima-web";

export class DownloadPage {
  oncreate(vnode) {
    window.scrollTo(0, 0);
  }

  oninit(vnode) {
    vnode.state.serialCodes = getSerialCodes();
    console.log(vnode.state.serialCodes.loaded)
    if(!vnode.state.serialCodes.loaded) {
      // データが読み込まれていない（リロードされたなど）
      m.route.set("/login");
    }
  }

  view(vnode) {
    return [
      m(SimpleHeader, APP_TITLE),
      m(MainLContent, [
        m("h2.m-txt-ttl2", "ご注文内容のご確認"),
        m(PackageInfoView, {serialCodes: vnode.state.serialCodes}),
        m(DownloadView, {serialCodes: vnode.state.serialCodes}),
        m(ResetBtnView, {serialCodes: vnode.state.serialCodes}),
      ]),
      m(SimpleFooter),
    ];
  }
}

class DownloadView {
  view(vnode) {
    return [
      m(BoxFrameView, [
        m("p.m-txt-p", [
          "学校名・ご採用教材名・ライセンス数などがご注文内容およびライセンス証書の記載と一致していることをご確認の上、「シリアルコード通知シート」をダウンロードしてください。",
        ]),
      ]),
      m("h3.m-txt-ttl3", "シリアルコード通知シート"),
      m(".m-list-btn.link-position-center", [
        m("ul[data-gs=12][data-gs-tab=2][data-gs-sp=1]", [
          m("li[data-gs-col=4]", [
            m("a[href=serial-codes.pdf][download].m-btn-simple", {
              onclick: e => {
                e.preventDefault();
                vnode.attrs.serialCodes.getPdf()
                  .then(blob => {
                    downloadBlob(blob, "serial-codes.pdf");
                  })
                  .catch(error => {
                    alert(error);
                  });
              },
            }, m("span", "結合PDF")),
          ]),
          m("li[data-gs-col=4]", [
            m("a[href=serial-codes.zip][download].m-btn-simple", {
              onclick: e => {
                e.preventDefault();
                vnode.attrs.serialCodes.getZip()
                  .then(blob => {
                    downloadBlob(blob, "serial-codes.zip");
                  })
                  .catch(error => {
                    alert(error);
                  });
              },
            }, m("span", "分割PDF （ZIP形式）")),
          ]),
          m("li[data-gs-col=4]", [
            m("a[href=serial-codes.csv][download].m-btn-common", {
              onclick: e => {
                e.preventDefault();
                vnode.attrs.serialCodes.getCsv()
                  .then(blob => {
                    downloadBlob(blob, "serial-codes.csv");
                  })
                  .catch(error => {
                    alert(error);
                  });
              },
            }, m("span", "CSVファイル")),
          ]),
        ]),
      ]),
      m(BoxFrameView, [
        m("ul.m-list-desc", [
          m("li", [
            "印刷して生徒に配布する場合は、",
            m("strong", "「結合PDF」"),
            "をご利用ください。",
            "（すべてのページが連続したPDFになっています。）",
          ]),
          m("li", [
            "生徒ごとにデータでPDFを配布する場合は、",
            m("strong", "「分割PDF」"),
            "をご利用ください。",
            "（ページごとに分割したPDFがZIP圧縮されています。）",
          ]),
          m("li", [
            "先生ご自身で差し込み印刷などをされる場合は、",
            m("strong", "「CSVファイル」"),
            "をご利用ください。",
          ]),
        ]),
      ]),
    ];
  }
}

class PackageInfoView {
  view(vnode) {
    return m("table.m-table-common.package-info", [
      m("tbody", [
        m("tr", [
          m("th", "学校名"),
          m("td", vnode.attrs.serialCodes.orgName),
        ]),
        m("tr", [
          m("th", "組織コード"),
          m("td", vnode.attrs.serialCodes.orgCode),
        ]),
        m("tr", [
          m("th", "ご採用教材名"),
          m("td", vnode.attrs.serialCodes.packageName),
        ]),
        m("tr", [
          m("th", "ライセンス数"),
          m("td", vnode.attrs.serialCodes.amount),
        ]),
        m("tr", [
          m("th", "ご利用期間"),
          m("td", [
            vnode.attrs.serialCodes.availableFrom,
            "～",
            vnode.attrs.serialCodes.availableTo,
          ]),
        ]),
      ]),
    ])
  }
}

class ResetBtnView {
  view(vnode) {
    return m(".m-list-btn.link-position-center", [
      m("ul[data-gs=12][data-gs-tab=2][data-gs-sp=1]", [
        m("li[data-gs-col=6]", [
          m("button[type=button].m-btn-common.btn-secondary", {
            onclick: e => {
              vnode.attrs.serialCodes.reset();
              m.route.set("/login");
            },
          }, "別のライセンスを確認する"),
        ]),
      ]),
    ]);
  }
}

function downloadBlob(blob, filename) {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
}